/**
 * The words of a staff badge (ADR-112 decision 4.2): the type's name, which is the badge's accessible name and its
 * hover line, with the leader's and the Guide's forms. `{type}` in `leader` is one of `type`; a Guide's four forms are
 * its four chevrons, which stand for the years served (ADR-112 decision 3.4).
 */
export const STAFF = {
  type: {
    administrator: "Administrator",
    support: "Player Support",
    events: "Events",
    builder: "Builder",
    designer: "Designer",
    guideLead: "Guide leader",
    guide: "Guide",
  },
  leader: "{type}, team leader",
  guide: { new: "Guide, new", oneYear: "Guide, 1 year", twoYears: "Guide, 2 years", threeYears: "Guide, 3 years or more" },
  command: {
    worn: "You wear the {type} badge.",
    wornHidden: "You wear the {type} badge, and it is hidden.",
    hidden: "Your badge is hidden.",
    shown: "Your badge is shown.",
    usage: "Use /badge to see your badge, /badge hide or /badge off to hide it, and /badge show or /badge on to show it. Your badge is the one a lead gives you.",
    session: "Your session has ended. Log in again.",
    sessionless: "This page has no account session to change a badge with.",
    forbidden: "Your roles do not allow that badge.",
    rate: "Badge changes are limited. Try again in {seconds} seconds.",
    rateLater: "Badge changes are limited. Try again in a minute.",
    unavailable: "The badge could not be saved. Try again.",
    failed: "The badge could not be changed.",
  },
} as const;
